import React, { useEffect, useState } from 'react';
import { Table, Button, Form, Row, Col } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { dedupedRequest } from '../../utils/axios';

const LegalAreasPanel = () => {
  const { token } = useAuth();
  const [legalAreas, setLegalAreas] = useState<any[]>([]);
  const [formData, setFormData] = useState({
    name: '',
    color: '#FFFFFF'
  });

  const loadLegalAreas = async () => {
    // console.log('Doing loadLegalAreas');
    dedupedRequest({ method: 'GET', url: '/admin/legal_areas' }, { useCache: true })
      .then(res => setLegalAreas(res.data))
      .catch(err => console.error("Failed to load legal_areas", err));
  };

  useEffect(() => {
    loadLegalAreas();
  }, [token]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    fetch('/api/admin/legal_areas', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData),
    })
    .then(newArea => {
      setLegalAreas([...legalAreas, newArea]);
      setFormData({ name: '', color: '#FFFFFF' });
    });
  };

  return (
    <>
      <h5>Legal Areas</h5>
      <Table striped bordered size="sm">
        <thead>
          <tr>
            <th>ID</th><th>Name</th><th>Color</th>
          </tr>
        </thead>
        <tbody>
          {legalAreas.map(a => (
            <tr key={a.id}>
              <td>{a.id}</td>
              <td>{a.name}</td>
              <td>
                <span
                  style={{
                    display: 'inline-block',
                    width: '1.5em',
                    height: '1.5em',
                    backgroundColor: a.color,
                    border: '1px solid #ccc'
                  }}
                />{' '}
                {a.color}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <h5>Neues Rechtsgebiet anlegen</h5>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-2">
          <Col xs="auto">
              <Form.Label>Farbe:</Form.Label>
          </Col>
          <Col xs="auto">
            <Form.Control
              type="color"
              value={formData.color}
              title="Farbe wählen"
              onChange={e => setFormData({ ...formData, color: e.target.value })}
            />
          </Col>
          <Col>
            <Form.Control
              placeholder="Rechtsgebietsname"
              value={formData.name}
              onChange={e => setFormData({ ...formData, name: e.target.value })}
              required
            />
          </Col>
        </Row>
        <Button type="submit">Rechtsgebiet speichern</Button>
      </Form>
    </>
  );
};

export default LegalAreasPanel;
